import { render, staticRenderFns } from "./RsaConfigurazionePostiLettoLettiViewComponent.vue?vue&type=template&id=46c20a22"
import script from "./RsaConfigurazionePostiLettoLettiViewComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazionePostiLettoLettiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports